export default __webpack_public_path__ + "static/media/btn-noten.db1d4a91.png";